<div class="space-y-6">
  <form [formGroup]="pinForm">
    <section id="section-redemption-pin" hlmCard>
      <div hlmCardHeader>
        <h2 hlmCardTitle>Einlöse-PIN für Mitarbeiter</h2>
        <p hlmCardDescription>
          Optional: 4–6-stellige PIN für die öffentliche Gutscheineinlösung. Leer lassen, um die
          öffentliche Einlösung zu deaktivieren.
        </p>
      </div>

      <div hlmCardContent class="space-y-4">
        <div hlmField>
          <label hlmFieldLabel for="redemption_pin">PIN (4–6 Stellen)</label>
          <hlm-input-group class="w-full sm:w-56">
            <input
              hlmInputGroupInput
              id="redemption_pin"
              [type]="showPin ? 'text' : 'password'"
              formControlName="redemption_pin"
              [placeholder]="showPin ? 'z. B. 1234' : '••••'"
              maxlength="6"
              inputmode="numeric"
              [attr.aria-invalid]="pinInvalid ? 'true' : null" />
            @if (pinForm.get('redemption_pin')?.value) {
              <hlm-input-group-addon align="inline-end">
                <button
                  hlmInputGroupButton
                  type="button"
                  [attr.aria-label]="showPin ? 'PIN verbergen' : 'PIN anzeigen'"
                  (click)="togglePinVisibility()">
                  <ng-icon [name]="showPin ? 'lucideEyeOff' : 'lucideEye'" />
                </button>
              </hlm-input-group-addon>
            }
          </hlm-input-group>
          @if (pinInvalid) {
            <p hlmFieldDescription class="text-destructive">PIN muss 4–6 Ziffern lang sein</p>
          }
        </div>

        @if (company?.redemption_blocked) {
          <div hlmAlert variant="warning">
            <ng-icon name="lucideLock" />
            <p hlmAlertTitle>Öffentliche Einlösung gesperrt</p>
            <p hlmAlertDescription>
              Die öffentliche Gutscheineinlösung wurde nach 3 fehlgeschlagenen PIN-Versuchen
              automatisch gesperrt. Fehlversuche: {{ company?.failed_pin_attempts || 0 }} / 3
            </p>

            @if (unblockSuccess) {
              <p hlmAlertDescription class="mt-2">
                Öffentliche Einlösung wurde erfolgreich entsperrt.
              </p>
            }
            @if (unblockError) {
              <p hlmAlertDescription class="mt-2">{{ unblockError }}</p>
            }

            <button
              hlmBtn
              variant="outline"
              size="sm"
              type="button"
              class="mt-2"
              [disabled]="unblocking"
              (click)="unblockRedemption()">
              @if (unblocking) {
                <hlm-spinner />
                Wird entsperrt…
              } @else {
                Entsperren
              }
            </button>
          </div>
        } @else if ((company?.failed_pin_attempts ?? 0) > 0) {
          <div hlmAlert>
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>
              {{ company?.failed_pin_attempts ?? 0 }} fehlgeschlagene PIN-Versuche
            </p>
            <p hlmAlertDescription>
              Bei 3 Fehlversuchen wird die öffentliche Einlösung automatisch gesperrt.
            </p>
          </div>
        }
      </div>

      <div hlmCardFooter class="justify-end border-t pt-4">
        <app-save-button
          #saveButton
          size="sm"
          [disabled]="!pinForm.valid || !formChanged"
          [loading]="loading"
          (clickEvent)="onSubmit()" />
      </div>
    </section>
  </form>

  <section hlmCard>
    <div hlmCardHeader>
      <h2 hlmCardTitle>So funktioniert die Einlösung</h2>
      <p hlmCardDescription>
        Schau dir das Tutorial an, um zu erfahren, wie du Gutscheine mit deinem Team einlöst.
      </p>
    </div>
    <div hlmCardContent>
      <div class="aspect-video overflow-hidden rounded-lg bg-black">
        <iframe
          class="size-full"
          src="https://www.youtube.com/embed/e-k6PXCARYw"
          title="Gutschein einlösen – Tutorial"
          frameborder="0"
          allow="
            accelerometer;
            autoplay;
            clipboard-write;
            encrypted-media;
            gyroscope;
            picture-in-picture;
          "
          allowfullscreen></iframe>
      </div>
    </div>
  </section>
</div>
